import { filter } from 'lodash'
import type { Schema } from '@wix/wix-data-schema-types'
import { FieldType } from '@wix/wix-data-schema-types'

export const countReferencesToCollection = (
  referencedCollectionId: string,
  collections: Schema[],
): number =>
  collections.reduce((numberOfReferringFields: number, collection: Schema) => {
    const referringFields = filter(
      collection.fields,
      field =>
        field.type === FieldType.reference &&
        field.referencedCollection === referencedCollectionId,
    )
    return numberOfReferringFields + Object.keys(referringFields).length
  }, 0)
